import { FormDataFromObject } from "@helpers";
import useApiController from "@hooks/useApiController";

export default function usePhotoController(): Customer.Controllers.Photo {
    const { index, show, store, destroy, ...controller } = useApiController("/api/customer/photos")

    const update = (id: string | number, data: object) => {
        return controller.update(id, FormDataFromObject(data, "patch"))
    }

    return { index, show, update, store, destroy }
}